import BodyText, { BODY_TEXT_SIZES } from "@shared/ui/BodyText";
import {
  ExternalIcon,
  EXTERNAL_ICON_SIZES,
  EXTERNAL_ICON_THUMB_BADGE_CLASS,
} from "@shared/ui/Indicators";
import { Checkbox, CHECKBOX_SIZES } from "@shared/ui/Inputs";

type AssignItemListItemPropsType = {
  isChecked: boolean;
  name: string;
  itemId: string;
  thumbnail?: string;
  visibilityScope?: string | null;
  subItemText?: string;
};

const AssignItemListItem = ({
  isChecked,
  name,
  itemId,
  thumbnail = "",
  visibilityScope,
  subItemText = "",
}: AssignItemListItemPropsType) => {
  const isExternal =
    String(visibilityScope || "").toLowerCase() === "external";

  return (
    <div className="list-item--boxed flex items-center cursor-pointer">
      <div className="overflow-hidden text-ellipsis whitespace-nowrap pr-xs flex-1 flex items-center min-w-0">
        <span className="relative h-3xl w-3xl rounded-lg overflow-visible mr-md flex-shrink-0">
          {thumbnail ? (
            <img
              src={thumbnail}
              alt={name}
              className="h-full w-full object-cover object-center rounded-lg"
            />
          ) : (
            <span className="block h-full w-full rounded-lg bg-brand-lightest" />
          )}
          {isExternal ? (
            <ExternalIcon
              size={EXTERNAL_ICON_SIZES.ACCORDION}
              className={EXTERNAL_ICON_THUMB_BADGE_CLASS}
            />
          ) : null}
        </span>
        <div className="flex flex-col min-w-0">
          <BodyText
            size={BODY_TEXT_SIZES.SMALL}
            className="truncate capitalize !font-bold"
            title={name}
          >
            {name}
          </BodyText>
          {(itemId || subItemText) && (
            <div className="flex items-center gap-xs min-w-0 pt-2xs">
              {itemId && (
                <BodyText
                  size={BODY_TEXT_SIZES.X_SMALL}
                  color="text-secondary"
                  className="truncate"
                  title={itemId}
                >
                  {itemId}
                </BodyText>
              )}
              {subItemText ? (
                <>
                  {itemId ? (
                    <span className="text-tertiary text-xs">•</span>
                  ) : null}
                  <BodyText
                    size={BODY_TEXT_SIZES.X_SMALL}
                    color="text-secondary"
                    className="whitespace-nowrap"
                  >
                    {subItemText}
                  </BodyText>
                </>
              ) : null}
            </div>
          )}
        </div>
      </div>
      <div className="mx-sm flex-shrink-0">
        <Checkbox size={CHECKBOX_SIZES.NORMAL} checked={isChecked} />
      </div>
    </div>
  );
};

export default AssignItemListItem;
